<soft-ds-multi-select size="lg"
                      searchable
                      filterMode="external"
                      showSelectionCount
                      showOnlySelectedToggle
                      dividers
                      [panelMinWidth]="320"
                      [panelMaxWidth]="384"
                      [leadingIcon]="item().config.icon"
                      [placeholder]="title()"
                      [items]="items()"
                      [hasMore]="hasMore()"
                      [loadingMore]="loading()"
                      [hasError]="loadFailed()"
                      [errorLabel]="'#CORE_FILTER.LOAD_ERROR' | translate"
                      [errorDescription]="loadErrorDetail()"
                      [retryLabel]="'#CORE_FILTER.RETRY' | translate"
                      (retry)="retry()"
                      [value]="draftKeys()"
                      (valueChange)="draftKeys.set($event ?? [])"
                      [search]="search()"
                      (searchChange)="search.set($event)"
                      (opened)="onOpened()"
                      (closed)="onClosed()"
                      (scrolledToEnd)="loadMore()"
                      [listboxFooter]="footer" />

<ng-template #footer>
  <div class="filter-select-footer" data-testid="filter-menu-bar-item-panel">
    <soft-ds-button variant="ghost" size="lg" (click)="clear()" data-testid="filter-menu-bar-item-clear">
      {{ '#CORE_FILTER.RESET' | translate }}
    </soft-ds-button>
    <soft-ds-button variant="primary" size="lg" (click)="apply()" data-testid="filter-menu-bar-item-apply">
      {{ '#CORE_FILTER.APPLY' | translate }}
    </soft-ds-button>
  </div>
</ng-template>
